import { hasPermission } from '../../resourcingRoute';
import ResourceAssignmentDialogWrapper from './ResourceAssignmentDialogWrapper';

const route = ({ intl, me }) => ({
  path: '/resourcing/assignment/:groupUri/:planStatus/:resourceRequestId',
  icon: () => null,
  hidden: true,
  title: () => intl.formatMessage({ id: 'resourceManagementList.details' }),
  component: ResourceAssignmentDialogWrapper,
  hasPermission: hasPermission(me)
});

export default route;
